import { useEffect } from 'react';
import $ from "jquery"
import "jquery-countdown/dist/jquery.countdown"
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';
import { Link } from 'react-router-dom';
import { fa_number } from '../../../../utils/PersianNum';

function Countdown() {
    const {data : {home: {countdown : {data,name,caption}}}} = useGetSettingQuery()

    useEffect(() =>{
        let finalDate = $('.time-countdown').data('countdown');
        $('.time-countdown').countdown(finalDate, function(event) {
            $('.time-countdown').html(event.strftime('<div class="counter-column"><div class="inner"><span class="count">%D</span>روز</div></div> <div class="counter-column"><div class="inner"><span class="count">%H</span>ساعت</div></div> <div class="counter-column"><div class="inner"><span class="count">%M</span>دقیقه</div></div>  <div class="counter-column"><div class="inner"><span class="count">%S</span>ثانیه</div></div>'));
        });
    },[])

    return ( 
        <section className="cart-banner pt-100 pb-100">
            <div className="container">
                <div className="row clearfix">
                    {/* <!--Image Column--> */}
                    <div className="image-column col-lg-6">
                        <div className="image">
                            <div className="price-box">
                                <div className="inner-price">
                                    <span className="price">
                                        <strong>{fa_number(data.num_offPercent)}</strong>٪ <br/> تخفیف
                                    </span>
                                </div>
                            </div>
                            <img src={data.img_image} alt=""/>
                        </div>
                    </div>
                    {/* <!--Content Column--> */}
                    <div className="content-column col-lg-6">
                        {name && <h3><span className="orange-text">{name.split(" ")[0]}</span> {name.split(" ").slice(1).join(" ")}</h3>}
                        <h4>{data.txt_name}</h4>
                        {caption && <div className="text">{caption}</div>}
                        {/* <!--Countdown Timer--> */}
                        <div className="time-counter"><div className="time-countdown clearfix" data-countdown={data.txt_offDate}><div className="counter-column"><div className="inner"><span className="count">۰۰</span>روز</div></div> <div className="counter-column"><div className="inner"><span className="count">۰۰</span>ساعت</div></div>  <div className="counter-column"><div className="inner"><span className="count">۰۰</span>دقیقه</div></div>  <div className="counter-column"><div className="inner"><span className="count">۰۰</span>ثانیه</div></div></div></div>
                        <Link to={`/product/${data.txt_id}`} className="cart-btn mt-3"><i className="fas fa-shopping-cart"></i> مشاهده جزئیات</Link>
                    </div>
                </div>
            </div>
        </section>
     );
}

export default Countdown;